import { SYSTEM_ROLES } from '../constants';

export const tabDetailsObjects = {
    notifications: { label: 'Notifications', name: 'userNotifications', icon: 'envelope', slug: 'notifications', permissions: [SYSTEM_ROLES.administrator.developerName, SYSTEM_ROLES.standard_user.developerName] }, // Only used in tab header
    userSettings: { label: 'User Settings', name: 'userSettings', icon: 'user', slug: 'user-settings', permissions: [SYSTEM_ROLES.administrator.developerName, SYSTEM_ROLES.standard_user.developerName] }, // Only used in tab header
    flows: { label: 'Flows', name: 'flows', icon: 'leaf', slug: 'flows', permissions: [SYSTEM_ROLES.administrator.developerName, SYSTEM_ROLES.standard_user.developerName] }, // Only used in sidebar
    pages: { label: 'Pages', name: 'pages', icon: 'th', slug: 'pages', permissions: [SYSTEM_ROLES.administrator.developerName, SYSTEM_ROLES.standard_user.developerName] },
    values: { label: 'Values', name: 'values', icon: 'record', slug: 'values', permissions: [SYSTEM_ROLES.administrator.developerName, SYSTEM_ROLES.standard_user.developerName] },
    services: { label: 'Services', name: 'services', icon: 'transfer', slug: 'services', permissions: [SYSTEM_ROLES.administrator.developerName, SYSTEM_ROLES.standard_user.developerName] },
    types: { label: 'Types', name: 'types', icon: 'option-vertical', slug: 'types', permissions: [SYSTEM_ROLES.administrator.developerName, SYSTEM_ROLES.standard_user.developerName] },
    assets: { label: 'Assets', name: 'assets', icon: 'picture', slug: 'assets', permissions: [SYSTEM_ROLES.administrator.developerName, SYSTEM_ROLES.standard_user.developerName] },
    flowLibrary: { label: 'Flow Library', name: 'flowlibrary', icon: 'book', slug: 'flow-library', permissions: [SYSTEM_ROLES.administrator.developerName, SYSTEM_ROLES.standard_user.developerName] },
    api: { label: 'API', name: 'build', icon: 'wrench', slug: 'api', permissions: [SYSTEM_ROLES.administrator.developerName, SYSTEM_ROLES.standard_user.developerName] },
    importExport: { label: 'Import / Export', name: 'import-export', icon: 'export', slug: 'import-export', permissions: [SYSTEM_ROLES.administrator.developerName, SYSTEM_ROLES.standard_user.developerName] },
    players: { label: 'Players', name: 'players', icon: 'play', slug: 'players', permissions: [SYSTEM_ROLES.administrator.developerName, SYSTEM_ROLES.standard_user.developerName] },
    macros: { label: 'Macros', name: 'macros', icon: 'cog', slug: 'macros', permissions: [SYSTEM_ROLES.administrator.developerName, SYSTEM_ROLES.standard_user.developerName] },
    dashboard: { label: 'Dashboard', name: 'dashboard', icon: 'dashboard', slug: 'dashboard', permissions: [SYSTEM_ROLES.administrator.developerName, SYSTEM_ROLES.standard_user.developerName] },
    auditing: { label: 'Auditing', name: 'audit', icon: 'list-alt', slug: 'auditing', permissions: [SYSTEM_ROLES.administrator.developerName, SYSTEM_ROLES.standard_user.developerName] },
};

// add keys that are common to all sidebar items
const sidebarDetails = {};
Object.entries(tabDetailsObjects).forEach(([tabKey, tabValue]) => {
    sidebarDetails[tabKey] = { ...tabValue, classes: [] };
});

export const Groups = [
    {
        name: 'admin',
        items: [
            { ...sidebarDetails.flows, tooltip: 'Manage existing and create new Flows', selected: true },
            { ...sidebarDetails.pages, tooltip: 'Manage existing and create new Pages' },
            { ...sidebarDetails.values, tooltip: 'Manage existing and create new Values' },
            { ...sidebarDetails.services, tooltip: 'Manage existing and create new Services' },
            { ...sidebarDetails.types, tooltip: 'Manage existing and create new Types' },
            { ...sidebarDetails.assets, tooltip: 'Upload static assets to your Tenant' },
        ],
    },
    {
        name: 'tools',
        label: 'Tools',
        items: [
            { ...sidebarDetails.flowLibrary, tooltip: 'Browse and install example flows, page templates and players' },
            { ...sidebarDetails.api, tooltip: 'Interact with the REST api directly' },
            { ...sidebarDetails.importExport, tooltip: 'Import & Export Flows' },
            { ...sidebarDetails.players, tooltip: 'Create, edit & preview custom players' },
            { ...sidebarDetails.macros, tooltip: 'Create or edit Macros' },
            { ...sidebarDetails.dashboard, tooltip: 'View the manager dashboard' },
            { ...sidebarDetails.auditing, tooltip: 'View the audit logs for this tenant' },
        ],
    },
    // {
    //     name: 'custom',
    //     label: 'Custom',
    //     items: [
    //         //{ label: 'Components', icon: 'paperclip', action: null }
    //     ]
    // },
];
